import { createElement } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { DepartmentPickerFieldExtension } from './DepartmentPicker';
import { DivisionPickerFieldExtension } from './DivisionPicker';
import { OwnerEmailPickerFieldExtension } from './OwnerEmailPicker';
import { DataOfficerFieldExtension } from './DataOfficerField';
import { ParticipationAgreementFieldExtension } from './ParticipationAgreementField';
import { AddUsersFieldExtension } from './AddUsersField';
import { SpokeAdminsFieldExtension } from './SpokeAdminsField';
import { ExternalDataLoadingRequiredFieldExtension } from './ExternalDataLoadingRequiredField';
import { AdoProjectNameFieldExtension } from './AdoProjectNameField';
import { DataTeamSetupFieldExtension } from './DataTeamSetupField';
import { RequestedByFieldExtension } from './RequestedByField';
import { RegionPickerFieldExtension } from './RegionPicker';
import { SpokeNameFieldExtension } from './SpokeNameField';
import { DatabricksWorkspaceFieldExtension } from './DatabricksWorkspaceField';
import {
  CatalogsAndSchemasFieldExtension,
  CatalogConflictGuardFieldExtension,
} from './CatalogsAndSchemasField';
import { ReviewSummaryFieldExtension } from './ReviewSummaryField';
import { ExistingCatalogSchemasFieldExtension } from './ExistingCatalogSchemasField/extensions';
import { UserGroupsFieldExtension } from './UserGroupsField';
import { UserGroupMembersFieldExtension } from './UserGroupMembersField';

export const scaffolderCustomizations = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    scaffolderPlugin
      .getExtension('sub-page:scaffolder/templates')
      .override({ params: { title: 'Request a Service' } }),
    // Override the tasks sub-page so logs are collapsed by default on the task
    // detail page. The task list route redirects to /create.
    scaffolderPlugin.getExtension('sub-page:scaffolder/tasks').override({
      params: {
        loader: async () => {
          const { CustomTasksSubPage } = await import('./CustomOngoingTask');
          return createElement(CustomTasksSubPage);
        },
      },
    }),
    scaffolderPlugin
      .getExtension('sub-page:scaffolder/actions')
      .override({ disabled: true }),
    scaffolderPlugin
      .getExtension('sub-page:scaffolder/editor')
      .override({ disabled: true }),
    scaffolderPlugin
      .getExtension('sub-page:scaffolder/templating-extensions')
      .override({ disabled: true }),
    DepartmentPickerFieldExtension,
    DivisionPickerFieldExtension,
    OwnerEmailPickerFieldExtension,
    DataOfficerFieldExtension,
    ParticipationAgreementFieldExtension,
    AddUsersFieldExtension,
    SpokeAdminsFieldExtension,
    ExternalDataLoadingRequiredFieldExtension,
    AdoProjectNameFieldExtension,
    DataTeamSetupFieldExtension,
    RequestedByFieldExtension,
    RegionPickerFieldExtension,
    SpokeNameFieldExtension,
    DatabricksWorkspaceFieldExtension,
    CatalogsAndSchemasFieldExtension,
    CatalogConflictGuardFieldExtension,
    ReviewSummaryFieldExtension,
    ExistingCatalogSchemasFieldExtension,
    UserGroupsFieldExtension,
    UserGroupMembersFieldExtension,
  ],
});
